import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class BusinessMetricsListController extends Controller {
  queryParams = ['search'];
  @tracked search = '';
  @tracked selectedMetric = null;
  @tracked selectedTargets = [];

  @action
  openChartModal(metric) {
    this.selectedMetric = metric;
    this.selectedTargets = metric.targets.content ?? [];
  }

  @action
  closeChartModal() {
    this.selectedMetric = null;
    this.selectedTargets = [];
  }

  @action
  deleteMetric(metric) {
    metric.destroyRecord();
  }
}
